import React from 'react';
import { Avatar, CircularProgress, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/system';

const style = {
    circularProgres: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};

const PorcentajeCiruclaV2 = ({ porcentaje = 0, text = '', nombre = '', color = 'warning', avatarSx = {}, progressProps = {} }) => {
    const theme = useTheme();
    const safeValue = Math.max(0, Math.min(100, Number(porcentaje) || 0));

    return (
        <Tooltip title={nombre} disableInteractive>
            <Avatar
                variant="rounded"
                sx={{
                    ...theme.typography.commonAvatar,
                    ...theme.typography.largeAvatar,
                    backgroundColor: theme.palette.warning.light,
                    color: theme.palette.warning.dark,
                    p: 4,
                    mb: 2,
                    ...avatarSx
                }}
            >
                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                    <CircularProgress size={50} variant="determinate" color={color} value={safeValue} {...progressProps} />
                    <Box sx={style.circularProgres}>
                        <Typography variant="caption" color="text.secondary">
                            {text}
                        </Typography>
                    </Box>
                </Box>
            </Avatar>
        </Tooltip>
    );
};

export default PorcentajeCiruclaV2;
